import cn from 'classnames'
import { PropsWithChildren } from 'react'

import styles from './RenderWhen.module.scss'

interface IRenderWhenProps extends PropsWithChildren {
  condition?: boolean
  keepMounted?: boolean
}

export const RenderWhen = ({ condition, children, keepMounted }: IRenderWhenProps) => {
  if (keepMounted) {
    return <div className={cn({ [styles.hidden]: !condition })}>{children}</div>
  }

  if (condition) {
    return <>{children}</>
  }

  return null
}

RenderWhen.displayName = 'RenderWhen'
